import { toolTransform } from '@backrs_ui/common-ui';

import { toAgentContextNugget } from '@backrs_ui/grow-ui/src/agentContext/toAgentContextNugget';
import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import type { CompletedSolutionSession } from './SolutionSessionsSection';

export const useAgentContext = (completedSessions: readonly CompletedSolutionSession[]) => {
  useRegisterAgentContext(
    completedSessions.length > 0
      ? {
          kind: 'nuggetList',
          description:
            'Solution sessions this student has completed. Use a solution_session_type with the get-solution-session tool to read what a session produced.',
          nuggets: completedSessions.map(({ sessionType, tool }) => ({
            ...toAgentContextNugget(toolTransform(tool)),
            metadata: { solution_session_type: sessionType },
          })),
        }
      : null,
  );
};
